import React, { useEffect, useState, useRef } from 'react';
import { Box, SimpleGrid, useToast, Flex, Button } from '@chakra-ui/react';
import DynamicTable from '../../../components/table/DynamicTable.js';
import { columnsDataTeaching } from './variables/columnsDataTeaching.js';
import { getData, postData } from '../../../utils/httpClient.js';
import { normalizeDocument } from '../../../utils/documentFormat';
import { useSearch } from '../../../contexts/SearchContext.js';
import CreateTeacherModal from '../../../components/teaching/CreateTeacherModal.js';
import ConfirmModal from '../../../components/modal/ConfirmModal.js';

const initialFormData = {
  name: '',
  secondName: '',
  lastName: '',
  maternalLastName: '',
  documentTypeId: '',
  document: '',
  birthDate: '',
  birthPlace: '',
  sexId: '',
  phone: '',
  cellPhone: '',
  email: '',
  street: '',
  number: '',
  apartment: '',
  city: '',
  locality: '',
  zipCode: '',
};

export default function Settings() {
  const { searchQuery, updateSearchQuery } = useSearch();
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [modalState, setModalState] = useState({
    isOpen: false,
    confirmModalOpen: false,
  });

  const [formData, setFormData] = useState(initialFormData);

  const rowsPerPage = 10;
  const toast = useToast();

  const latestRequestRef = useRef(0);

  const getTeachers = async (dato) => {
    const requestId = ++latestRequestRef.current;
    try {
      const response = await getData(
        `/person/employee?page=${page + 1}&limit=${rowsPerPage}&data=${dato}`,
      );
      if (requestId !== latestRequestRef.current) return;
      setData(response?.payload?.people || []);
      setTotalPages(Math.ceil(response?.payload?.total / rowsPerPage));
    } catch (error) {
      if (requestId !== latestRequestRef.current) return;
      toast({
        title: 'Error al obtener docentes',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const createPostData = (formData) => {
    return {
      name: formData.name,
      secondName: formData.secondName,
      lastName: formData.lastName,
      maternalLastName: formData.maternalLastName,
      documentTypeId: formData.documentTypeId,
      document: normalizeDocument(formData.document),
      phone: formData.phone,
      cellPhone: formData.cellPhone,
      email: formData.email,
      birthPlace: formData.birthPlace,
      birthDate: formData.birthDate,
      sexId: formData.sexId,

      // Dirección personal
      address: {
        street: formData.street,
        number: formData.number,
        apartment: formData.apartment,
        zipCode: formData.zipCode,
        city: formData.city,
        locality: formData.locality,
      },

      employee: {
        employeeTypeId: 1, // Default teacher type
      },
    };
  };

  const createTeacher = async () => {
    try {
      const newTeacher = createPostData(formData);
      console.log(newTeacher);
      const response = await postData('/person/register', newTeacher);
      if (response?.payload) {
        toast({
          title: 'Docente creado con éxito',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        closeModal();
      }
    } catch (error) {
      toast({
        title: 'Error al crear docente',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    getTeachers(searchQuery);
  }, [page, searchQuery]);

  const resetForm = () => {
    setFormData(initialFormData);
  };

  const openModal = () => {
    setModalState({
      isOpen: true,
      confirmModalOpen: false,
    });
  };

  const closeModal = () => {
    setModalState({
      isOpen: false,
      confirmModalOpen: false,
    });
    resetForm();
  };

  const showConfirmModal = () => {
    setModalState({
      isOpen: true,
      confirmModalOpen: true,
    });
  };

  const hiddeConfirmModal = () => {
    setModalState({
      isOpen: true,
      confirmModalOpen: false,
    });
  };

  const handleConfirm = async () => {

    await createTeacher();
    closeModal();
    await getTeachers();
  };

  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <Flex justify="flex-end" mb={4}>
        <Button colorScheme="blue" onClick={() => openModal()}>
          Nuevo docente
        </Button>
      </Flex>
      <SimpleGrid
        mb="20px"
        columns={{ sm: 1 }}
        spacing={{ base: '20px', xl: '20px' }}
      >
        <DynamicTable
          columnsData={columnsDataTeaching}
          data={data}
          page={page}
          setPage={setPage}
          totalPages={totalPages}
          showRowInfo={true}
          rowClickPath="/admin/teaching/:id"
          openModal={openModal}
        />
      </SimpleGrid>

      <CreateTeacherModal
        isOpen={modalState.isOpen}
        onClose={showConfirmModal}
        formData={formData}
        setFormData={setFormData}
        onConfirm={handleConfirm}
      />

      <ConfirmModal
        isOpen={modalState.confirmModalOpen}
        onClose={hiddeConfirmModal}
        onConfirm={closeModal}
        header="Confirmación de Cancelación"
        message="¿Estás seguro de que deseas cancelar? Todos los datos no guardados se perderán."
      />
    </Box>
  );
}
